import React from 'react'
import { Grid } from '@chakra-ui/core'

//grid grid-rows-welcome grid-cols-1 min-h-screen
const WelcomeGrid: React.FC = ({ children }) => {
	return (
		<Grid gridTemplateRows={'100px 1fr 50px'} minH='100vh' maxH='100%'>
			{children}
		</Grid>
	)
}

export default WelcomeGrid
